module.exports = __webpack_public_path__ + "static/img/rail-text-1.968ecfec.png";